import { CheckCircle2, Phone, Package, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useCart } from "@/context/CartContext";
import { BRAND } from "@/lib/content";
import { formatINR } from "@/lib/useReveal";

export const OrderSuccess = () => {
  const { confirmedOrder, setConfirmedOrder } = useCart();
  if (!confirmedOrder) return null;
  const o = confirmedOrder;

  return (
    <div className="fixed inset-0 z-[115] flex items-center justify-center bg-black/70 px-4">
      <div
        data-testid="order-success-dialog"
        className="max-h-[92vh] w-full max-w-md overflow-y-auto rounded-2xl bg-white p-7 text-center shadow-2xl"
      >
        <CheckCircle2 className="mx-auto h-16 w-16 text-emerald-500" />
        <h2 className="mt-4 font-display text-2xl text-neutral-900">Order Confirmed!</h2>
        <p className="mt-2 text-sm text-neutral-600">
          Thank you {o.full_name}! Your order has been received.
        </p>

        <div className="mt-5 rounded-xl border border-neutral-200 bg-[var(--hp-page)] p-4 text-left">
          <div className="flex items-center justify-between text-sm">
            <span className="text-neutral-500">Order Number</span>
            <span data-testid="order-number" className="font-num font-bold text-[var(--hp-crimson)]">
              {o.order_number}
            </span>
          </div>
          <div className="mt-3 space-y-2 border-t border-neutral-200 pt-3">
            {o.items.map((it, i) => (
              <div key={i} className="flex justify-between text-sm">
                <span className="text-neutral-700">
                  {it.title} × {it.qty}
                </span>
                <span className="font-num font-semibold">{formatINR(it.price * it.qty)}</span>
              </div>
            ))}
          </div>
          <div className="mt-3 flex justify-between border-t border-neutral-200 pt-3 text-base font-bold">
            <span>Total (COD)</span>
            <span className="font-num text-[var(--hp-crimson)]">{formatINR(o.total)}</span>
          </div>
        </div>

        <div className="mt-4 space-y-2 text-left text-sm text-neutral-600">
          <div className="flex items-center gap-2">
            <Package className="h-4 w-4 text-[var(--hp-crimson)]" /> Delivery in 2 to 4 days
          </div>
          <div className="flex items-center gap-2">
            <ShieldCheck className="h-4 w-4 text-[var(--hp-crimson)]" /> Discreet and secure packaging
          </div>
          <div className="flex items-center gap-2">
            <Phone className="h-4 w-4 text-[var(--hp-crimson)]" /> For any help: {BRAND.phone}
          </div>
        </div>

        <Button
          data-testid="order-success-close-button"
          onClick={() => setConfirmedOrder(null)}
          className="mt-6 h-12 w-full bg-neutral-900 text-base font-bold text-white hover:bg-neutral-800"
        >
          Continue Shopping
        </Button>
      </div>
    </div>
  );
};
